import { render, staticRenderFns } from "./IncomeCostList.vue?vue&type=template&id=24dfbe1a&scoped=true&"
import script from "./IncomeCostList.vue?vue&type=script&lang=js&"
export * from "./IncomeCostList.vue?vue&type=script&lang=js&"
import style0 from "./IncomeCostList.vue?vue&type=style&index=0&id=24dfbe1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dfbe1a",
  null
  
)

export default component.exports